export default __webpack_public_path__ + "static/media/G0750.34I-27930_-16873_0.1666265160000.57369c7d.jpg";